import React, { useEffect, useState } from "react";
import styles from "../Service/Service.module.css";
import service_Type_Data from "../../Data/RO-landing.json";
import { TiTick } from "react-icons/ti";

const Service = () => {
  // filtering service type data and storing in avariable using useEffect Hook....
  const [serviceType, setServiceType] = useState({});

  useEffect(() => {
    let service_Data = service_Type_Data.map((elem) =>
      elem.cards.filter((sT) => sT.cardType == "service")
    );

    setServiceType(service_Data);
  }, []);
  return (
    <>
      <div className={styles.container}>
        {serviceType[0]?.map((elem, index) => {
          return (
            <div className={styles.card}>
              <>
                <img src={elem.cardBanner} alt={elem.cardBanner} />
                <h3>{elem.title}</h3>
                <h4>{elem.covers}</h4>
                {/* mapping all notes  */}
                <h4 className={styles.notes}>
                  {elem.notes.map((dt) => (
                    <p>
                      {<TiTick />}
                      {dt}
                    </p>
                  ))}
                </h4>
                <div className={styles.card_Inner}>
                  <h4> Rs. {elem.price} /-</h4>
                  <p>*T&C Apply</p>
                  <button>Book Now</button>
                </div>
              </>
            </div>
          );
        })}
      </div>
    </>
  );
};

export default Service;
